import { useEffect, useRef, useState } from 'react';
import useParticipants from '../../src/hooks/useParticipants/useParticipants';
const useUpdateVisibleUsers = (props) => {
    const { attendees, mode, debugMode = false } = props;
    const participants = useParticipants();
    const [visibleAttendeeCount, setVisibleAttendeeCount] = useState(0);
    const [page, setPage] = useState(0);
    const visibleAttendeesRef = useRef([]);
    const filterParticipant = (identity, attendeeId, type) => {
        const idParts = identity.split('.');
        return idParts[0] === attendeeId && idParts[1] === type;
    };
    useEffect(() => {
        recalculate();
    }, [participants, visibleAttendeeCount, page, attendees]);
    const updateUsers = (visibleAttendeeCount, page) => {
        setVisibleAttendeeCount(visibleAttendeeCount);
        setPage(page);
    };
    const recalculate = () => {
        // For instance, (example cases)
        // if page 1 and vissible attendee 5 and total items 16 => 1 to 5
        // if page 2 and vissible attendee 5 and total items 16 => 6 to 11
        // if page 3 and vissible attendee 5 and total items 16 => 11 to 16
        // special case
        // if page 1 and vissible attendee 5 and total items 6 => 1 to 5
        // if page 1 and vissible attendee 5 and total items 6 => 2 to 6
        const from = (visibleAttendeeCount * (page - 1) + 1);
        const to = from + visibleAttendeeCount;
        const videoParticipants = new Set(participants.map((x) => x.identity.split('.')[0]));
        // Host user
        const host = attendees.find((e) => e.id === 'host');
        const isLast = page === Math.ceil((videoParticipants.size - (mode === 'Guest' ? 1 : 0)) / visibleAttendeeCount);
        // Debug parameter
        let visibleUsersByName = null;
        // To avoid mutate the initial list, host will be added later
        const attendeeList = [...attendees]
            .filter(attendee => (['CONNECTED', 'ACCEPTED'].includes(attendee.status) && attendee.id !== 'host'));
        // when n - 1 last page special case, // See te comment above, -1 is because the array start in the position [0]
        const viewPortAttendees = isLast ? attendeeList.slice(-visibleAttendeeCount) : attendeeList.slice(from - 1, to - 1);
        // Adding the user host
        host && viewPortAttendees.push(host);
        // Pinned user also should be added here, TODO future implementation
        const visibleAttendee = viewPortAttendees
            .map(attendee => (attendee.id));
        if (page > 0 && visibleAttendee.length > 0) {
            participants.forEach((participant) => {
                participant.videoTracks.forEach((track) => {
                    var _a, _b, _c;
                    if (track.trackName.startsWith('camera')) {
                        const isNotVisible = !viewPortAttendees.find((x) => x.identity === participant.identity);
                        if (isNotVisible !== ((_a = track.track) === null || _a === void 0 ? void 0 : _a.isSwitchedOff)) {
                            isNotVisible ? (_b = track.track) === null || _b === void 0 ? void 0 : _b.switchOff() : (_c = track.track) === null || _c === void 0 ? void 0 : _c.switchOn();
                        }
                    }
                });
            });
            if (debugMode) {
                visibleUsersByName = visibleAttendee.map(attendee => {
                    var _a;
                    return (_a = participants.find(e => filterParticipant(e.identity, attendee, 'video'))) === null || _a === void 0 ? void 0 : _a.identity;
                });
                // eslint-disable-next-line no-console
                console.info('Updates Sid', visibleAttendeesRef.current, 'Updates Attendees', visibleUsersByName);
            }
        }
        else {
            // No attendees
            return [];
        }
    };
    return { updateUsers };
};
export default useUpdateVisibleUsers;
//# sourceMappingURL=useUpdatedVisibleUsers.js.map